export default __webpack_public_path__ + "static/media/RobotoCondensed-Regular.db6d9169.ttf";